// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3StSI","messages":"Chat_messages__3zc6f","dateDivider":"Chat_dateDivider__2DQ1Q"};